import { useCallback, useEffect, useRef, useState } from "react";
import "./SidebarRailTooltip.css";

const SHOW_MS = 200;
const HIDE_MS = 40;

export default function SidebarRailTooltip({ text, children, enabled = true, naturalWidth = false }) {
  const [open, setOpen] = useState(false);
  const showTimer = useRef(null);
  const hideTimer = useRef(null);

  const clearTimers = useCallback(() => {
    if (showTimer.current) clearTimeout(showTimer.current);
    if (hideTimer.current) clearTimeout(hideTimer.current);
    showTimer.current = null;
    hideTimer.current = null;
  }, []);

  const scheduleShow = useCallback(() => {
    clearTimers();
    showTimer.current = setTimeout(() => setOpen(true), SHOW_MS);
  }, [clearTimers]);

  const scheduleHide = useCallback(() => {
    clearTimers();
    hideTimer.current = setTimeout(() => setOpen(false), HIDE_MS);
  }, [clearTimers]);

  useEffect(() => () => clearTimers(), [clearTimers]);

  if (!enabled || !text) {
    return children;
  }

  const rootClass = naturalWidth
    ? "sidebar-rail-tooltip-root sidebar-rail-tooltip-root--natural"
    : "sidebar-rail-tooltip-root";

  function handleBlurCapture(e) {
    const { relatedTarget } = e;
    if (relatedTarget && e.currentTarget.contains(relatedTarget)) return;
    scheduleHide();
  }

  return (
    <span
      className={rootClass}
      onMouseEnter={scheduleShow}
      onMouseLeave={scheduleHide}
      onFocusCapture={scheduleShow}
      onBlurCapture={handleBlurCapture}
    >
      {children}
      <span className={`sidebar-rail-tooltip${open ? " is-visible" : ""}`} role="presentation">
        {text}
      </span>
    </span>
  );
}
